import React from "react"
import { Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core"
import Markdown from "markdown-to-jsx"
import PropTypes from "prop-types"
import {
    AMd,
    LiMd,
    UlMd,
    ThMd,
    PaperTableMd,
    PaperMd,
    GMapMd,
    DenseTableMd,
    IndexSpacerMd,
    HeaderMd,
    PMd,
    WorkshopMd,
    DisruptorMd, RegistrationMd, DateMd,
    SpanMd,
} from "./mdComponents/mdComponents"
import deepMerge from "deepmerge"
import { withContainer } from "./mdComponents/withContainer"
import { MyContainer } from "./container"

export const markdownOptions = {
    disableParsingRawHTML: false,
    // forceBlock: true,
    overrides: {
        ...[1, 2, 3, 4, 5, 6].reduce((result, item, index) => {
            result[`h${item}`] = {
                component: HeaderMd,
                props: {
                    variant: item,
                },
            }
            return result
        }, {}),

        p: PMd,
        span: SpanMd,
        a: AMd,
        li: LiMd,
        ul: UlMd,
        table: ({ children }) => <Table children={children}/>,
        thead: TableHead,
        th: ThMd,
        tr: TableRow,
        td: TableCell,
        tbody: TableBody,
        GMap: GMapMd,
        DenseTable: DenseTableMd,
        PaperTable: PaperTableMd,
        Paper: PaperMd,
        IndexSpacer: IndexSpacerMd,
        Workshop: WorkshopMd,
        Disruptor: DisruptorMd,
        Registration: RegistrationMd,
        Date: DateMd,
    },
}

export const markdownOptionsContainer = deepMerge(markdownOptions, {
    overrides: {
        ...[1, 2, 3, 4, 5, 6].reduce((result, item, index) => {
            result[`h${item}`] = {
                component: withContainer(HeaderMd),
                props: {
                    variant: item,
                },
            }
            return result
        }, {}),
        p: withContainer(PMd),
        Paper: withContainer(PaperMd),
    },
})

export const MyMarkdown = ({ options, children, variant, vars, ...props }) => {
    const localOptions = {
        overrides: {
            Var: ({ name }) => <span>{vars[name]}</span>,
        },
    }

    const opt = options ? [options] : []
    const opts = deepMerge.all([variant === "multiple" ? markdownOptionsContainer : markdownOptions, localOptions, ...opt])

    if (variant === "single") {
        return <MyContainer>
            <Markdown
                children={children}
                options={opts}
                {...props}
            />
        </MyContainer>
    }

    return <Markdown
        children={children}
        options={opts}
        {...props}
    />
}

MyMarkdown.propTypes = {
    children: PropTypes.node.isRequired,
    options: PropTypes.object,
    variant: PropTypes.oneOf(["none", "single", "multiple"]),
}

MyMarkdown.defaultProps = {
    variant: "none",
}